/* eslint-disable no-unused-vars */
/** @format */
import { useCallback } from "react";
import React from "react";
import { PAGE_SIZE } from "utils/constant.data";

const WebinarPagination = ({ metadata, setFilter }) => {
  const totalPages = Math.ceil(metadata?.count / metadata?.page_size);

  const handlePageChange = useCallback(
    (newPage) => {
      if (newPage >= 1 && newPage <= totalPages) {
        setFilter("");
      }
    },
    [setFilter, totalPages]
  );

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    setFilter(`page=1&page_size=${newItemsPerPage}`);
  };

  return (
    <div className="pagination-container">
      <div className="pagination-controls">
        <span className="pagination-text">Show</span>
        <select
          className="pagination-select"
          value={metadata?.page_size}
          onChange={handleItemsPerPageChange}
        >
          {PAGE_SIZE?.map((size) => (
            <option key={size} value={size}>
              {size}
            </option>
          ))}
        </select>
        <span className="pagination-text">Entries</span>
      </div>

      {/* <>
        {totalPages > 1 && (
          <>
            <button
              className="pagination-btn"
              onClick={() => handlePageChange(1)}
              disabled={metadata?.page === 1}
            >
              &laquo;
            </button>
            <button
              className="pagination-btn"
              onClick={() => handlePageChange(metadata?.page - 1)}
              disabled={metadata?.page === 1}
            >
              &lt;
            </button>

            <button
              className={`pagination-btn ${
                metadata?.page === 1 ? "pagination-btn-active" : ""
              }`}
              onClick={() => handlePageChange(1)}
            >
              1
            </button>

            {totalPages > 1 && (
              <>
                {metadata?.page > 4 && (
                  <span className="pagination-ellipsis">...</span>
                )}

                {[...Array(Math.min(5, Math.max(0, totalPages - 2)))].map(
                  (_, i) => {
                    let page;
                    if (metadata?.page < 4) {
                      page = i + 2;
                    } else if (metadata?.page > totalPages - 3) {
                      page = totalPages - 5 + i;
                    } else {
                      page = metadata?.page - 2 + i;
                    }
                    if (page > 1 && page < totalPages) {
                      return (
                        <button
                          key={page}
                          className={`pagination-btn ${
                            metadata?.page === page
                              ? "pagination-btn-active"
                              : ""
                          }`}
                          onClick={() => handlePageChange(page)}
                        >
                          {page}
                        </button>
                      );
                    }
                    return null;
                  }
                )}

                {metadata?.page < totalPages - 3 && totalPages > 5 && (
                  <span className="pagination-ellipsis">...</span>
                )}

                {totalPages > 1 && (
                  <button
                    className={`pagination-btn ${
                      metadata?.page === totalPages
                        ? "pagination-btn-active"
                        : ""
                    }`}
                    onClick={() => handlePageChange(totalPages)}
                  >
                    {totalPages}
                  </button>
                )}
              </>
            )}

            <button
              className="pagination-btn"
              onClick={() => handlePageChange(metadata?.page + 1)}
              disabled={metadata?.page === totalPages}
            >
              &gt;
            </button>
            <button
              className="pagination-btn"
              onClick={() => handlePageChange(totalPages)}
              disabled={metadata?.page === totalPages}
            >
              &raquo;
            </button>
          </>
        )}
      </> */}
    </div>
  );
};

export default WebinarPagination;
